<template>
    <div class="home-ownership-home">
        <home-large-cover
                @addressInput="handleAddressInput"
                @click-claim-my-home="handleClaimMyHomeClick"
                :overlay-color="landingPage.primaryColor"
        />

        <home-ownership-home-body />
    </div>
</template>

<script>
import "./HomeOwnershipHome.scss";
import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";
import ShowNotificationMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin";
import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
import {HOME_IMAGES} from "../../../../../helpers/images";
import LandingPageActionAppResource
    from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageActionAppResource";
import {
    HOME_OWNERSHIP as HOME_OWNERSHIP_ACTION
} from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageActionAppResource";
import WorkspaceOrganizationMemberAppResource
    from "@milestoneslabs/milestones-core-js/src/AppResources/WorkspaceOrganizationMemberAppResource";
import AppResourceSearch from "@milestoneslabs/milestones-js-engine/src/Data/AppResourceSearch";
import ApiFilter from "@milestoneslabs/milestones-js-engine/src/Api/ApiFilter";
import {HOME_OWNERSHIP as HOME_OWNERSHIP_TYPE}
    from "@milestoneslabs/milestones-core-js/src/AppResources/WorkspaceTypeAppResource";
import HomeOwnershipHomeBody from "./HomeOwnershipHomeBody/HomeOwnershipHomeBody";
import HomeLargeCover from "../../HomeLargeCover/HomeLargeCover";
import {INTERSTITIAL_MODAL_REDIRECT} from "../../../Modals/InterstitiallModal/InterstitialModal";
import {getRedirectLinkToNewProject} from "../../../../../helpers/modals";
import QueryStrings from "@milestoneslabs/milestones-unified-login/src/QueryStrings";
import get from 'lodash/get';
import HOHAddressMixin from "./HOHAddressMixin";
import AddressAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/AddressAppResource";

export default {
    name: "HomeOwnershipHome",
    components: {
        HomeLargeCover,
        HomeOwnershipHomeBody,
    },

    mixins: [
        ShowNotificationMixin,
        IsMobileMixin,
        HOHAddressMixin,
    ],

    props: {
        landingPage: {
            type: LandingPageAppResource,
            default: () => {
                return new LandingPageAppResource({});
            }
        }
    },

    data() {
        return {
            homeSection: this.landingPage.home,
            projectTypeAppResource: new WorkspaceOrganizationMemberAppResource({}),
        };
    },

    computed: {
        actions() {
            return [
                new LandingPageActionAppResource({
                    attributes: {
                        active: true,
                        displayText: this.homeSection.actionButtonText,
                        type: HOME_OWNERSHIP_ACTION,
                        redirectQueryParams: {
                            type: this.projectTypeAppResource.uuid,
                        }
                    }
                }),
            ];
        },

        companyLogo() {
            return (this.landingPage.organizationLogo || {}).publicStorageUrl || null;
        },

        displayName() {
            return this.landingPage.displayName || this.landingPage.firstName + ' ' + this.landingPage.lastName;
        },
    },

    methods: {
        async fetchHomeOwnershipHubType() {
            let projectTypeSearch = new AppResourceSearch('workspace-type');

            await projectTypeSearch.setSearchData({
                filter: new ApiFilter({
                    params: {
                        type: HOME_OWNERSHIP_TYPE,
                    }
                }),
            });

            try {
                await projectTypeSearch.search();

                if (projectTypeSearch.appResourceCollection.isNotEmpty) {
                    this.projectTypeAppResource = projectTypeSearch.appResourceCollection.getFirst();
                }
            } catch (e) {
                console.warn(e);
            }
        },

        handleAddressInput(address) {
            if (!address) {
                console.warn('Address is not valid: ', address);

                return;
            }

            this.$router.push({
                name: 'landing-page.hub-preview',
                query: {
                    [QueryStrings.HOH_ADDRESS]: this.getEncodedAddress(address)
                }
            });
            return;

            let redirectLink = getRedirectLinkToNewProject({
                brandedLogin: window.brandedLogin,
                type: this.projectTypeAppResource.uuid,
                hohAddress: btoa(address),
                landingPageUuid: this.landingPage.uuid,
            });

            this.$bus.$emit(INTERSTITIAL_MODAL_REDIRECT, redirectLink);
        },

        handleClaimMyHomeClick(address) {
            if (!address) {
                console.warn('handleClaimMyHomeClick Address is not valid: ', address);
                return;
            }

            if (address instanceof AddressAppResource) {
                address.generateFullAddress();
            }
            if (!address.fullAddress) {
                address = {
                    fullAddress: address,
                    city: '',
                    country: '',
                    state: '',
                    postalCode: '',
                    street: '',
                    streetNumber: '',
                };
            }

            this.$router.push({
                name: 'landing-page.hub-preview',
                query: {
                    [QueryStrings.HOH_ADDRESS]: this.getEncodedAddress(address)
                }
            });
        },
    },

    async beforeMount() {
        localStorage.removeItem('hohEmail');
        let query = Object.assign({}, this.$route.query);
        if (get(this.$route.query, 'email')) {
            localStorage.setItem('hohEmail', get(this.$route.query, 'email'));
            delete query.email;
        }
        await this.$router.replace({query});
        await this.fetchHomeOwnershipHubType();
    }
};
</script>
